import GetRenderView from '../GetRenderView';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME,
  MEDICAL_HEALTH_INFORMATION_NAME
} from '../constants/constants';
import Layout from './Layout';
import { useNavigate } from 'react-router';
import { useMedicalHealthInformationContext } from '../Context';
import { useEffect, useState } from 'react';

const MedicalHealthInformationForm = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('医療健康情報一覧');
  const { activeStep, setActiveStep, detailStep, facilityName } = useMedicalHealthInformationContext();

  useEffect(() => {
    if (activeStep === MEDICAL_HEALTH_INFORMATION_NAME || activeStep === MEDICAL_HEALTH_INFORMATION_DETAIL_NAME) {
      setTitle('医療健康情報一覧');
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME) {
      setTitle('画像一覧');
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME) {
      setTitle('動画一覧');
    } else {
      setTitle(facilityName);
    }
  }, [activeStep, facilityName]);

  const handleBackClick = () => {
    if (activeStep === MEDICAL_HEALTH_INFORMATION_NAME) {
      navigate('/patient/top');
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_NAME) {
      setActiveStep(MEDICAL_HEALTH_INFORMATION_NAME);
    } else if (
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME ||
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME ||
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME ||
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME ||
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME ||
      activeStep === MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME
    ) {
      setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_NAME);
    } else if (activeStep === MEDICAL_HEALTH_INFORMATION_DETAIL_NAME) {
      if (detailStep === MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME) {
        setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME);
      } else if (detailStep === MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME) {
        setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME);
      } else if (detailStep === MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME) {
        setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME);
      }
    } else {
      navigate('/patient/top');
    }
  };

  return (
    <>
      <Layout title={title} handleBack={handleBackClick}>
        {GetRenderView(activeStep)}
      </Layout>
    </>
  );
};
export default MedicalHealthInformationForm;
